<template>
  <v-app>
    <v-content>
      <sponsor-form></sponsor-form>
    </v-content>
  </v-app>
</template>

<script>
import SponsorForm from "./components/SponsorForm";
export default {
  name: "App",
  components: {
    SponsorForm,
  },
};
</script>
